import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const getCategory = async (user) => {
    const response = await axios.get(`${API_URL}/company/myquotes/category/`, {
        headers: {
            Authorization: "Bearer " + user.token
        }
    });
    const categoryData = response.data.category;

    return {
        category: categoryData?.category || "",
        companyName: categoryData?.companyName || "",
        isGeneral: categoryData?.isGeneral ?? true,
        isPremium: categoryData?.isPremium ?? true,
        isUpdatable: categoryData?.category ? true : false,
    };
};


export const saveCategory = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN); 
    const response = await axios.post(`${API_URL}/company/myquotes/category/createCategory`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateCategory = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/myquotes/category`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};
